export const splitCopyInTwo = (text: string) => {
    // splits a string in half by whole word
    let middle = Math.floor(text.length / 2);

    const before = text.lastIndexOf(' ', middle);
    const after = text.indexOf(' ', middle + 1);

    if (before === -1 || (after !== -1 && middle - before >= after - middle)) {
        middle = after;
    } else {
        middle = before;
    }

    const s1 = text.slice(0, middle);
    const s2 = text.slice(middle + 1);

    return { s1, s2 };
};
